import React from "react";

import { createStore, Provider } from "jotai";

export const RebudgetingTableStore = createStore();

export const useTableStore = () => {
  return RebudgetingTableStore;
};

export const RebudgetingTableProvider = ({
  children,
}: {
  children: React.ReactNode[] | React.ReactNode;
}) => {
  return <Provider store={RebudgetingTableStore}>{children}</Provider>;
};
